import React from 'react';
import { CheckboxProps } from 'semantic-ui-react';

import WarningMessage from '@modules/common/components/banners/WarningMessage';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import Checkbox from '@modules/common/components/Checkbox';
import config from '@config/config';

type Props = {
  hasAcceptedExpiryRisk?: boolean;
  setHasAcceptedExpiryRisk?: (value: boolean) => void;
};

function Warning({ hasAcceptedExpiryRisk, setHasAcceptedExpiryRisk }: Props) {
  return (
    <StyledWarningMessageWrapper>
      <WarningMessage>
        <p>
          Client Secrets with long expiration lifetime pose a security risk. While they offer
          convenience of a never expiring credential, an exposure of such an unmonitored credential
          could go undetected and potentially be misused by a malicious actor. We strongly recommend
          to rotate client secrets every 3 months to keep apps and processes safe.
        </p>

        {setHasAcceptedExpiryRisk && (
          <StyledCheckbox>
            <Checkbox
              label="I understand the risks and I wish to proceed anyway."
              checked={hasAcceptedExpiryRisk}
              onChange={(_: any, data: CheckboxProps) =>
                setHasAcceptedExpiryRisk(Boolean(data.checked))
              }
            />
          </StyledCheckbox>
        )}
      </WarningMessage>
    </StyledWarningMessageWrapper>
  );
}

export default Warning;

const StyledWarningMessageWrapper = styled('div')`
  margin-bottom: 1rem;
`;

const StyledCheckbox = styled('p')`
  display: flex;
  flex-direction: row;

  .checkbox > label {
    color: ${config.terciaryTextColor} !important;
    font-weight: 700 !important;
    font-size: 16px;
  }
`;
